import view from './index.vue'

export default {
	view
}
